
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { useFormContext } from 'react-hook-form';
import { useState, KeyboardEvent } from 'react';
import { Tag, X } from 'lucide-react';

const DealTagsField = () => {
    const useFormReturn = useFormContext();
    const { control } = useFormReturn;
    const [inputValue, setInputValue] = useState('');

    return (
        <FormField
            control={control}
            name="tags"
            render={({ field }) => {
                const tags = Array.isArray(field.value) ? field.value : [];

                const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
                    if (e.key === 'Enter') {
                        e.preventDefault();
                        const trimmedValue = inputValue.trim();
                        if (trimmedValue && !tags.includes(trimmedValue)) {
                            field.onChange([...tags, trimmedValue]);
                            setInputValue('');
                        }
                    } else if (e.key === 'Backspace' && !inputValue && tags.length > 0) {
                        field.onChange(tags.slice(0, -1));
                    }
                };

                const removeTag = (indexToRemove: number) => {
                    field.onChange(tags.filter((_: string, index: number) => index !== indexToRemove));
                };

                return (
                    <FormItem>
                        <FormLabel className="mb-2 flex items-center gap-1.5 text-[10.5px] font-medium uppercase tracking-[0.12em] text-slate-500">
                            <Tag className="h-3 w-3 text-slate-500" />
                            Tags
                        </FormLabel>
                        <FormControl>
                            <div className="flex min-h-[42px] flex-wrap items-center gap-1.5 rounded-xl border border-white/[0.06] bg-white/[0.02] p-2 transition focus-within:border-brand-500/40">
                                {tags.map((tag: string, index: number) => (
                                    <span
                                        key={index}
                                        className="inline-flex items-center gap-1 rounded-md border border-brand-500/30 bg-brand-500/15 px-2 py-0.5 text-[11.5px] text-brand-200"
                                    >
                                        {tag}
                                        <button
                                            type="button"
                                            onClick={() => removeTag(index)}
                                            className="text-brand-300 transition-colors hover:text-white"
                                        >
                                            <X size={12} />
                                        </button>
                                    </span>
                                ))}
                                <Input
                                    placeholder={tags.length === 0 ? "Type and press Enter to add tags" : "Add more..."}
                                    value={inputValue}
                                    onChange={(e) => setInputValue(e.target.value)}
                                    onKeyDown={handleKeyDown}
                                    className="h-auto min-w-[120px] flex-1 border-0 bg-transparent p-0 text-[12.5px] text-slate-200 outline-none placeholder:text-slate-500 focus-visible:ring-0 focus-visible:ring-offset-0"
                                />
                            </div>
                        </FormControl>
                        <FormMessage className="text-[10.5px] text-accent-red" />
                    </FormItem>
                );
            }}
        />
    )
}

export default DealTagsField
